/* STARKAIR PRO – Buybox (sections/sf-air-buybox.liquid), SF-STARKAIR-PRO-BUYBOX-20260930.
   1. Galerie: Daumen <-> Wischreihe (nur < 1024 px sichtbar)
   2. Warteliste: STL Ops Formular 55ec489c (GET /challenge -> Nonce, nach minSubmitSeconds POST JSON)
   3. Kopfzeile dunkel schalten, solange das helle Blatt unter ihr liegt */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var CONSENT_TEXT_VERSION = window.SFAB_CONSENT_TEXT_VERSION || 'starkair-drop-001-2026-09-23';
  var SIGNUP_SOURCE = 'starkair_drop_001_buybox';
  var SUBMIT_MARGIN_MS = 1000;
  var CHALLENGE_REUSE_MS = 30 * 60 * 1000;

  function initGallery(root) {
    var track = root.querySelector('[data-sfab-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sfab-thumb]'));
    if (!track || !thumbs.length) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-sfab-slide]'));

    function setActive(i) {
      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      var t = thumbs[i];
      if (t && t.parentNode && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
        var p = t.parentNode;
        var left = t.offsetLeft - (p.clientWidth - t.offsetWidth) / 2;
        p.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = Number(t.getAttribute('data-sfab-thumb')) || 0;
        var s = slides[i];
        if (!s) return;
        track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6) setActive(Number(e.target.getAttribute('data-sfab-slide')) || 0);
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }

    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var cur = thumbs.findIndex ? thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }) : 0;
      var next = Math.min(slides.length - 1, Math.max(0, cur + (e.key === 'ArrowRight' ? 1 : -1)));
      thumbs[next].click();
    });
  }

  function initWaitlist(root) {
    var form = root.querySelector('.sfab__form');
    var input = root.querySelector('.sfab__input');
    var button = root.querySelector('.sfab__submit');
    var label = root.querySelector('[data-sfab-label]');
    var errorEl = root.querySelector('.sfab__error');
    var successEl = root.querySelector('.sfab__wait-success');
    if (!form || !input || !button) return;
    var trap = form.querySelector('input[name="website"]');
    var buttonLabel = label ? label.textContent : '';
    var endpoint = (root.getAttribute('data-endpoint') || '').trim();
    var challenge = null, challengePromise = null, requestedAt = 0;

    function showError(msg, invalidInput) {
      if (invalidInput) input.setAttribute('aria-invalid', 'true');
      if (errorEl) { errorEl.textContent = msg; errorEl.classList.add('is-visible'); }
    }
    function clearError() {
      input.removeAttribute('aria-invalid');
      if (errorEl) { errorEl.textContent = ''; errorEl.classList.remove('is-visible'); }
    }
    function setBusy(busy) {
      button.disabled = busy;
      form.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (label) label.textContent = busy ? 'Wird eingetragen …' : buttonLabel;
    }

    function prepare() {
      if (challenge && Date.now() - requestedAt < CHALLENGE_REUSE_MS) return Promise.resolve(challenge);
      if (challengePromise) return challengePromise;
      if (!endpoint) return Promise.reject(new Error('endpoint missing'));
      var pending = fetch(endpoint + '/challenge', { mode: 'cors', credentials: 'omit', cache: 'no-store' })
        .then(function (res) { if (!res.ok) throw new Error('challenge HTTP ' + res.status); return res.json(); })
        .then(function (data) {
          if (!data || typeof data.nonce !== 'string' || !data.nonce) throw new Error('challenge invalid');
          challenge = data;
          requestedAt = Date.now();
          return data;
        });
      challengePromise = pending;
      pending.then(function () { challengePromise = null; }, function () { challengePromise = null; });
      return pending;
    }
    function warm() { prepare().catch(function () {}); }
    function waitForMinimum(data) {
      var minMs = Math.max(0, Number(data.minSubmitSeconds) || 0) * 1000 + SUBMIT_MARGIN_MS;
      var remaining = Math.max(0, minMs - (Date.now() - requestedAt));
      return new Promise(function (resolve) { setTimeout(function () { resolve(data); }, remaining); });
    }
    function subscribe(email) {
      return prepare().then(waitForMinimum).then(function (data) {
        /* Eine Nonce gilt fuer genau einen Versuch (der Server verwirft Wiederholungen stumm mit 202). */
        challenge = null;
        return fetch(endpoint, {
          method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            nonce: data.nonce,
            email: email,
            website: trap ? trap.value : '',
            locale: 'de',
            signup_source: SIGNUP_SOURCE,
            consentTextVersion: CONSENT_TEXT_VERSION
          })
        });
      }).then(function (res) {
        if (res.ok) return true;
        throw new Error('HTTP ' + res.status);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();
      var email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        showError('Bitte gib eine gültige E-Mail-Adresse ein.', true);
        input.focus();
        return;
      }
      setBusy(true);
      subscribe(email).then(function () {
        root.classList.add('is-success');
        if (successEl) {
          successEl.hidden = false;
          try { successEl.focus({ preventScroll: true }); } catch (err) { successEl.focus(); }
        }
      }).catch(function (err) {
        showError('Das hat nicht geklappt. Bitte versuche es gleich noch einmal.', false);
        if (window.console) console.warn('[sf-air-buybox] subscribe failed:', err);
      }).then(function () { setBusy(false); });
    });
    form.addEventListener('focusin', warm, { once: true });
    form.addEventListener('pointerdown', warm, { once: true });
    input.disabled = false;
    button.disabled = false;
    form.removeAttribute('aria-disabled');
  }

  function initTrustbox(root) {
    var el = root.querySelector('[data-sfab-tp]');
    if (!el) return;
    var tries = 0;
    (function go() {
      if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') { window.Trustpilot.loadFromElement(el, true); return; }
      if (tries++ < 40) setTimeout(go, 250);
    })();
  }

  function initHeader(root) {
    if (!('IntersectionObserver' in window)) return;
    var html = document.documentElement;
    var header = document.querySelector('.header-section .header') || document.querySelector('.header');
    var h = header ? Math.round(header.getBoundingClientRect().height) || 80 : 80;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { html.classList.toggle('sfab-hdr', e.isIntersecting); });
    }, { rootMargin: '0px 0px -' + Math.max(0, window.innerHeight - h) + 'px 0px', threshold: 0 });
    io.observe(root);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sfab]'), function (root) {
      var g = root.querySelector('[data-sfab-gallery]');
      if (g) initGallery(g);
      var w = root.querySelector('[data-sfab-wait]');
      if (w) initWaitlist(w);
      initTrustbox(root);
      initHeader(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
